module.exports = __webpack_public_path__ + "img/uk.ed31b81a.svg";